"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _SplitButton["default"];
  }
});
var _SplitButton = _interopRequireDefault(require("react-bootstrap/lib/SplitButton"));


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-react-components/lib/SplitButton.js
// module id = 6419
// module chunks = 25